import React from "react";
import { imageCodes, textCodes, titleCodes } from "../../template_codes/asteria/portfolio_page_codes";
const photoGallery = Object.keys(imageCodes).map(key => imageCodes[key].image);
function Portfolio() {
    return (
        <React.Fragment>
            <div>
                <div className="container lg:w-4/5 xl:w-3/5 px-4 pt-10">
                    <div className="text-center">
                        <h1 className="text-xl lg:text-4xl xl:text-4xl font-semibold pb-10">{titleCodes.portfolio.title}</h1>
                        <h1 className="text-lg pt-2 lg:text-xl xl:text-xl pb-10">{textCodes.porttext.text}</h1>
                    </div>
                </div>
                <div className="place-content-center">
                    <div className="container grid grid-cols-4 mx-auto">
                        {photoGallery.map(img => (
                            <div className="w-full p-2 rounded">
                                <img alt="gallery" src={img} className="block object-cover object-center w-full h-full rounded-lg" />
                            </div>
                        ))}

                    </div>
                </div>
            </div>

        </React.Fragment>
    );
}

export default Portfolio;